<main class="content-container"><app-auth-placeholder message="AUTHENTICATION.CLOSING"></app-auth-placeholder></main>
